export { default as AttachmentsDumb } from './attachments-dumb';
